import { render, staticRenderFns } from "./ConfirmFamilyModal.vue?vue&type=template&id=2ddf4f07&scoped=true"
import script from "./ConfirmFamilyModal.vue?vue&type=script&lang=js"
export * from "./ConfirmFamilyModal.vue?vue&type=script&lang=js"
import style0 from "./ConfirmFamilyModal.vue?vue&type=style&index=0&id=2ddf4f07&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ddf4f07",
  null
  
)

export default component.exports